/*
 * fn: getSetIcon
 *
 * Gets the set icon URL from a Scryfall icon URI
 *
 */
import { CARD_IMAGE_BASE } from '@/defs/misc'

export const getSetIcon = (iconSvgUri?: string) => {
  const file = iconSvgUri?.split('/').pop()

  return !file ? undefined : `${CARD_IMAGE_BASE}/sets/${file}`
}
